import { Dispatch, SetStateAction } from 'react';

import { ItemIdentifiersType, SelectedItemType } from '../types';

import { isMatchForSelectedItem } from './isMatchForSelectedItem';

// Remove items from selectedItems array that match id, color, and size
export const removeSelectedItem = (
  itemToRemove: ItemIdentifiersType,
  setSelectedItems: Dispatch<SetStateAction<SelectedItemType[]>>,
  selectedItems: SelectedItemType[]
) => {
  if (!itemToRemove) return;
  const updatedSelectedItems = selectedItems.filter(selectedItem => {
    return !isMatchForSelectedItem(itemToRemove, selectedItem);
  });
  setSelectedItems(updatedSelectedItems);
};

// Add new item to selectedItems array
export const addSelectedItem = (
  itemToAdd: SelectedItemType,
  setSelectedItems: Dispatch<SetStateAction<SelectedItemType[]>>,
  selectedItems: SelectedItemType[]
) => {
  setSelectedItems([...selectedItems, itemToAdd]);
};
